import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of } from "rxjs";

/**
 * Add data: { preload: true } to route to preload
 */
@Injectable({ providedIn: "root" })
export class AppPreloadingStrategy extends PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route?.data?.preload ? load() : of(null);
  }
}
